import React, { useMemo } from 'react';

import { InfoCircleFill as InfoCircleIcon } from '@styled-icons/bootstrap/InfoCircleFill';
import { Warning as WarningIcon } from '@styled-icons/fluentui-system-filled/Warning';

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  Button,
  Icon,
} from '@chakra-ui/react';

import { AlertRootProps } from 'components/Alert/Root';

const GenericAlert: React.FC<AlertRootProps> = ({
  type,
  title,
  description,
  buttons,
  onConfirm,
  handleClose,
  size = 'md',
  ...restProps
}) => {
  const cancelRef = React.useRef<HTMLButtonElement>(null);

  const getAlertDescription = (
    descr?: string | (() => JSX.Element),
  ): string | JSX.Element => {
    if (descr) {
      return typeof descr === 'string' ? descr : descr();
    }

    return '';
  };

  const icon = useMemo((): JSX.Element => {
    if (type === 'danger') {
      return <Icon as={WarningIcon} w={6} h={6} color="red.500" />;
    }

    if (type === 'warning') {
      return <Icon as={WarningIcon} w={6} h={6} color="orange.500" />;
    }

    return <Icon as={InfoCircleIcon} w={6} h={6} color="blue.300" />;
  }, [type]);

  const colorScheme = useMemo(() => {
    if (type === 'danger') {
      return 'red';
    }

    if (type === 'warning') {
      return 'orange';
    }

    return 'blue';
  }, [type]);

  return (
    <AlertDialog
      isOpen
      isCentered
      motionPreset="scale"
      leastDestructiveRef={cancelRef}
      onClose={handleClose}
      size={size}
      {...restProps}
    >
      <AlertDialogOverlay />

      <AlertDialogContent>
        <AlertDialogHeader display="flex" alignItems="center" gap={2}>
          {icon} {title}
        </AlertDialogHeader>

        <AlertDialogCloseButton />

        <AlertDialogBody>{getAlertDescription(description)}</AlertDialogBody>

        <AlertDialogFooter>
          <Button ref={cancelRef} onClick={handleClose}>
            {buttons?.[0] || 'Cancelar'}
          </Button>

          <Button
            ml={3}
            colorScheme={colorScheme}
            onClick={() => {
              if (onConfirm) onConfirm();
              handleClose();
            }}
          >
            {buttons?.[1] || 'Confirmar'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default GenericAlert;
